import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useProgrammeAccess, useProjectAccess } from '../context/AuthContext';

const NO_ACCESS = {
  role: null,
  loading: false,
  isAdmin: false,
  isViewer: false,
  isMember: false,
  canWrite: false,
  hasAccess: false,
};

/** Programme/project write gating from outlet context + DB resolver RPCs. */
export default function useWorkspaceAccess() {
  const ctx = useOutletContext() || {};
  const programmeId = ctx.programme?.id ?? null;
  const projectId = ctx.project?.id ?? ctx.projects?.[0]?.id ?? null;
  const projectAccess = useProjectAccess(projectId);
  const programmeAccess = useProgrammeAccess(programmeId);

  return useMemo(() => {
    if (projectId) return projectAccess;
    if (programmeId) return programmeAccess;
    return NO_ACCESS;
  }, [projectId, programmeId, projectAccess, programmeAccess]);
}
